export const getStatusColor = (status: string | undefined) => {
  if (status === 'SUCCESS' || status === 'REFUNDED') {
    return 'text--green';
  }
  if (status === 'TRACK APPLICATION') {
    return 'text--green';
  }
  if (status === 'FAILURE' || status === 'BLOCKED' || status === 'FAILED') {
    return 'text--red';
  }
  if (status === 'IN_PROGRESS') {
    return 'text--progress-color';
  }
  // Default class when status doesn't match any condition
  return 'text--black';
};

export const toTitleCase = (str: string | undefined): string => {
  if (!str) return 'N/A'; // Return an empty string if str is undefined
  return str
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\bupi\b/gi, 'UPI')
    .replace(/(?:^|\s)\w/g, (match) => match.toUpperCase());
};

export const formatDate = (dateString: string | undefined): string => {
  if (!dateString) return 'N/A'; // Return an empty string if dateString is undefined
  const date = new Date(dateString);
  const day = date.getDate();
  let suffix = '';
  switch (day) {
    case 1:
    case 21:
    case 31:
      suffix = 'st';
      break;
    case 2:
    case 22:
      suffix = 'nd';
      break;
    case 3:
    case 23:
      suffix = 'rd';
      break;
    default:
      suffix = 'th';
  }
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear().toString().substr(-2);
  return `${day}${suffix} ${month} '${year}`;
};
export const divideByTwelve = (rate: number) => {
  const result = rate / 12;
  return result.toFixed(2);
};
export const getTimeInFormat = (dateString: any) => {
  const date = new Date(dateString);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedHours}:${formattedMinutes} ${period}`;
};
